export default ({ store }, inject) => {
  inject('isFeatureEnabled', feature => store.getters['user/account/isFeatureEnabled'](feature))
}
